<ng-container *ngIf="hasError">
  <ng-template #errorComponent></ng-template>
</ng-container>
